import type { AnalyticsData } from '@mwl/core-lib';
import { formatUrlToStr } from '@mwl/core-lib';

import type { GetChampionshipListAnalytics } from './ChampionshipList.types';

export const getChampionshipListAnalytics: GetChampionshipListAnalytics = ({
  id,
  categoryId,
  href,
  title,
  championships,
  sportId,
}) => {
  const analyticsData: AnalyticsData = {
    id,
    href: formatUrlToStr(href),
    text: title,
    count: championships.length,
    position: championships.findIndex((category) => category.id === id) + 1,
    sport_category: sportId,
    category: categoryId,
    championships: title,
  };

  return {
    championshipAnalytics: {
      select: {
        eventName: 'sportLeftSideBar_championshipsList_select',
        data: analyticsData,
      },
      unselect: {
        eventName: 'sportLeftSideBar_championshipsList_unselect',
        data: analyticsData,
      },
    },
  };
};
